import React, { useState } from "react";
import { useParams } from "react-router-dom"; // Adjust according to your routing setup
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import StarRatings from "react-star-ratings";
import Breadcrumbs from "Components/Common/Breadcrumb";
import { useGetProductById } from "hooks/useProduct";
import { readableDate } from "utils";
import ProductImagePlaceholder from "../../assets/images/placeholder/product.png";
import Spinners from "Components/Common/Spinner";
import { useSelector } from "react-redux";

const ProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // Get the product ID from URL params
  const { data: productDetail, isLoading } = useGetProductById(id || ""); // Default to an empty string if id is undefined
  const [selectedImage, setSelectedImage] = useState(0);

  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Products" breadcrumbItem="Product Detail" />
        {isLoading ? (
          <Spinners />
        ) : (
          productDetail && (
            <Card className="mb-4 shadow-sm">
              <CardBody>
                <Row>
                  <Col md={6}>
                    <div className="product-detail-imgs">
                      <Row>
                        <Col sm={3}>
                          {/* <div> */}
                          {/* Thumbnail Images */}
                          {productDetail.images &&
                          productDetail.images.length > 0 ? (
                            productDetail.images.map((image, index) => (
                              <img
                                key={index}
                                src={image.url}
                                alt={`Thumbnail ${index}`}
                                className="img-fluid rounded mb-2 mr-2 d-block"
                                onClick={() => setSelectedImage(index)}
                                style={{
                                  objectFit: "cover",
                                  aspectRatio: "4/6",
                                  cursor: "pointer",
                                  height: "100px",
                                  borderRadius: "8px",
                                }}
                              />
                            ))
                          ) : (
                            <div className="no-image-placeholder">
                              <p>No images available</p>
                            </div>
                          )}
                          {/* </div> */}
                        </Col>
                        <Col sm={9}>
                          {/* Main Image Display */}
                          <img
                            src={
                              productDetail.images.length
                                ? productDetail.images[selectedImage].url
                                : ProductImagePlaceholder
                            }
                            alt="Main Product"
                            className="img-fluid mb-3"
                            style={{ borderRadius: "8px", height: "350px" }}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <Col md={6}>
                    <h4 className="mt-1 mb-3">{productDetail.name}</h4>
                    <div className="text-muted float-start me-3">
                      <StarRatings
                        rating={productDetail.rating || 0}
                        starRatedColor="#F1B44C"
                        starEmptyColor="#74788d"
                        numberOfStars={5}
                        name="rating"
                        starDimension="20px"
                        starSpacing="5px"
                      />
                    </div>
                    <p className="text-muted mb-4">
                      ({productDetail.reviews || 0} Customers Review)
                    </p>
                    <h5 className="mb-4">
                      Price:{" "}
                      <b>
                        {defaultCurrency}{" "}
                        {productDetail.selling_price.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </b>
                    </h5>
                    <p className="text-muted mb-4">
                      {productDetail.description}
                    </p>
                    <p className="text-muted mb-1">
                      <strong>SKU:</strong> {productDetail.sku}
                    </p>
                    <p className="text-muted mb-1">
                      <strong>Weight:</strong> {productDetail.weight}{" "}
                      {productDetail.weight_unit}
                    </p>
                    <p className="text-muted mb-1">
                      <strong>Quantity:</strong> {productDetail.quantity}
                    </p>
                    <p className="text-muted mb-1">
                      <strong>Barcode:</strong> {productDetail.barcode}
                    </p>
                    {productDetail?.expiry_date && (
                      <p className="text-muted mb-1">
                        <strong>Expiry Date:</strong>{" "}
                        {readableDate(productDetail.expiry_date)}
                      </p>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )
        )}
      </Container>
    </div>
  );
};

export default ProductDetail;
